// @flow
import {ActionsObservable, ofType} from 'redux-observable';
import {saveAccountApi} from './api';
import {map, switchMap} from 'rxjs/operators';
import {ActionCreator, buildCatchError, createReducer} from '../../store/utils';

import type {User} from '../../entities';
import type {Action} from '../../store/utils';
import type {SaveAccountRequest} from './api';

export type ProfileAction = Action & {
  error?: string,
  user?: User,
  data?: SaveAccountRequest,
};

export type ProfileState = {
  isSaving?: boolean,
  error?: string,
  savingSuccess?: boolean,
};

export class SaveAccountSettings extends ActionCreator<ProfileAction> {}
export class SaveAccountSettingsSuccess extends ActionCreator<ProfileAction> {}
export class SaveAccountSettingsErrorFn extends ActionCreator<ProfileAction> {}
export class SaveAccountResetState extends ActionCreator<ProfileAction> {}

export const actions = {
  saveAccountSettings: (payload: ProfileAction) =>
    new SaveAccountSettings(payload),
  resetState: () => new SaveAccountResetState(),
};

export const initialState = {};

export default createReducer(initialState, {
  [SaveAccountSettings.type]: _ => ({isSaving: true}),
  [SaveAccountSettingsSuccess.type]: _ => ({savingSuccess: true}),
  [SaveAccountSettingsErrorFn.type]: (_, action: ProfileAction) => ({
    error: action.error,
  }),
  [SaveAccountResetState.type]: _ => initialState,
});

export function saveAccountEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(SaveAccountSettings.type),
    switchMap((data: ProfileAction) =>
      saveAccountApi(data).pipe(
        map((user: User) => new SaveAccountSettingsSuccess({user})),
        buildCatchError(SaveAccountSettingsErrorFn)
      )
    )
  );
}
